// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__fR12q"};